import * as ACTION_TYPES from './holidayActionTypes';

// List holidays
export const getHolidayListRequest = () => ({
    type: ACTION_TYPES.LIST_HOLIDAY_REQUEST
});
export const getHolidayListRequestSuccess = data => ({
    type: ACTION_TYPES.LIST_HOLIDAY_REQUEST_SUCCESS,
    payload: {
        data
    }
});
export const getHolidayListRequestFailure = error => ({
    type: ACTION_TYPES.LIST_HOLIDAY_REQUEST_FAILURE,
    payload: {
        error
    }
});

export const clearHolidayList = () => ({
    type: ACTION_TYPES.CLEAR_LIST_HOLIDAY
});

// New holiday actions
export const newHolidayRequest = params => ({
    type: ACTION_TYPES.NEW_HOLIDAY_REQUEST,
    payload: {
        params
    }
});
export const newHolidayRequestSuccess = data => ({
    type: ACTION_TYPES.NEW_HOLIDAY_REQUEST_SUCCESS,
    payload: {
        data
    }
});
export const newHolidayRequestFailure = error => ({
    type: ACTION_TYPES.NEW_HOLIDAY_REQUEST_FAILURE,
    payload: {
        error
    }
});

//Delete holiday
export const deleteHolidayRequest = () => ({
    type: ACTION_TYPES.DELETE_HOLIDAY_REQUEST
});
export const deleteHolidayRequestSuccess = data => ({
    type: ACTION_TYPES.DELETE_HOLIDAY_REQUEST_SUCCESS,
    payload: {
        data
    }
});
export const deleteHolidayRequestFailure = error => ({
    type: ACTION_TYPES.DELETE_HOLIDAY_REQUEST_FAILURE,
    payload: {
        error
    }
});

//Edit holiday
export const editHolidayRequest = () => ({
    type: ACTION_TYPES.EDIT_HOLIDAY_REQUEST
});
export const editHolidayRequestSuccess = data => ({
    type: ACTION_TYPES.EDIT_HOLIDAY_REQUEST_SUCCESS,
    payload: {
        data
    }
});
export const editHolidayRequestFailure = error => ({
    type: ACTION_TYPES.EDIT_HOLIDAY_REQUEST_FAILURE,
    payload: {
        error
    }
});

// Holiday to edit
export const setHolidayToEdit = data => ({
    type: ACTION_TYPES.SET_HOLIDAY_TO_EDIT,
    payload: {
        data
    }
});

// Holiday types
export const getHolidayTypeListRequest = () => ({
    type: ACTION_TYPES.HOLIDAY_TYPE_LIST_REQUEST
});
export const getHolidayTypeListRequestSuccess = data => ({
    type: ACTION_TYPES.HOLIDAY_TYPE_LIST_REQUEST_SUCCESS,
    payload: {
        data
    }
});
export const getHolidayTypeListRequestFailure = error => ({
    type: ACTION_TYPES.HOLIDAY_TYPE_LIST_REQUEST_FAILURE,
    payload: {
        error
    }
});
